import { render } from "../templates/panes.html?vue&type=template&id=2949a62e"
import script from "./panes.vue?vue&type=script&lang=js"
export * from "./panes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__